"use client";
import { memo, useMemo } from "react";
import ProjectHero from "./ProjectHero";
import ProjectDetails from "./ProjectDetails";
import ProjectSidebar from "./ProjectSidebar";
import ProjectCTA from "./ProjectCTA";
import ImageGallery from "./ImageGallery";
import { Project } from "@/types/Projects";
import VideoPlayer from "./VideoPlayer";

function ProjectDetailClientComponent({ project }: { project: Project }) {
  const {
    title,
    description,
    fullDescription,
    gradient,
    tags,
    techStack,
    challenges,
    solutions,
    demoLink,
    githubLink,
    gallery,
    // videoUrl,
  } = useMemo(() => project, [project]);

  const buttonGradientStyles =
    "text-white text-base px-8 py-6 rounded-2xl bg-gradient-to-r from-blue-600 via-blue-500 to-blue-400 hover:from-blue-500 hover:via-blue-400 hover:to-blue-300 shadow-lg hover:shadow-xl transition-all duration-500 group dark:from-gray-900 dark:via-gray-800 dark:to-gray-700 dark:hover:from-gray-800 dark:hover:via-gray-700 dark:hover:to-gray-600";

  // const fallbackVideo =
  //   videoUrl ||
  //   "https://cdn.coverr.co/videos/coverr-working-on-laptop-5322/1080p.mp4";

  const fallbackGallery =
    gallery && gallery.length > 0
      ? gallery
      : [
          "/gallery/gallery-ai-neural.jpg",
          "/gallery/gallery-code-ai.jpg",
          "/gallery/gallery-ai-cloud.jpg",
          "/gallery/gallery-dev-dashboard.jpg",
        ];

  return (
    <div className="bg-background text-foreground">
      <ProjectHero
        gradient={gradient}
        tags={tags}
        title={title}
        description={description}
        buttonGradientStyles={buttonGradientStyles}
        image={project.image}
      />

      <VideoPlayer gradient={gradient} />

      <ImageGallery images={fallbackGallery} />

      <section className="py-16">
        <div className="container mx-auto px-6 grid lg:grid-cols-3 gap-8">
          <ProjectDetails
            fullDescription={fullDescription}
            challenges={challenges}
            solutions={solutions}
          />
          <ProjectSidebar
            techStack={techStack}
            demoLink={demoLink}
            githubLink={githubLink}
            buttonGradientStyles={buttonGradientStyles}
          />
        </div>
      </section>

      <ProjectCTA buttonGradientStyles={buttonGradientStyles} />
    </div>
  );
}

export default memo(ProjectDetailClientComponent);
